import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardStandard as OCardStandardComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardStandardConfig = {
  emptyLabel: 'OCardStandard',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-standard`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardStandard = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-standard-comp"
      data-component-name="o-card-standard"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardStandardConfig} {...props}>
        <OCardStandardComp {...props} />
      </EditableComponent>
    </div>
  );
};
